const appSettings = {
  //apiUrl : 'https://192.168.0.124/api/v3',
  //pentahoBaseURL : 'https://192.168.0.124:8080/pentaho',
  apiUrl: 'https://dispex.org/api/v5',
  localApiUrl: 'https://dispex.org:5000/v6',
  pentahoBaseURL: 'https://dispex.org:8080/pentaho',
  windowHeightDelta: 185,
  MessageEditBoxHeight: 55,
};
export default appSettings;
